<template lang="pug">
  div.logs
    md-table(md-theme="white")
      md-table-row(v-for="log in logs" v-bind:key="log.id")
        md-table-cell
          .text(v-html="log.description")
        md-table-cell.time {{ ((log.created_at) ? moment(log.created_at, 'YYYY.MM.DD HH:mm:ss').format('DD-MM-YYYY HH:mm') : '' ) }}
</template>

<script>
  import moment from "moment"
  export default {
    name: 'comments',
    props: [
      'module_id',
      'entity',
      'entity_id'
    ],
    data() {
      return {
        logs: []
      }
    },
    created() {
      this.getLogs();
    },
    watch: {
      '$props.entity_id'() {
        this.getLogs();
      }
    },
    computed: {

    },
    methods: {
      getLogs() {
        if (!this.issetData()) return;
        this.$store.dispatch('logs/getLogs', {
          entity_type: this.$props.entity,
          entity_id: this.$props.entity_id
        });
      },
      issetData() {
        return (
          this.$props.entity_id && this.$props.entity &&
            typeof this.$props.entity_id === 'number' &&
            typeof this.$props.entity === 'string'
        );
      }
    }
  }
</script>
<style scoped lang="sass"></style>



// WEBPACK FOOTER //
// logs.vue?591311ae